/* unplugin-vue-components disabled */import { ElButton as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElRow as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/row/style/css';
import { ElCol as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/col/style/css';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-ab72db5c"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "information"
};

const _hoisted_2 = /*#__PURE__*/_createTextVNode("账号名称");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("认证类型");

const _hoisted_4 = /*#__PURE__*/_createTextVNode("已认证");

const _hoisted_5 = /*#__PURE__*/_createTextVNode("去认证");

const _hoisted_6 = /*#__PURE__*/_createTextVNode("认证名称");

const _hoisted_7 = /*#__PURE__*/_createTextVNode("所属企业");

const _hoisted_8 = /*#__PURE__*/_createTextVNode("飞行员认证");

const _hoisted_9 = /*#__PURE__*/_createTextVNode("已认证");

const _hoisted_10 = /*#__PURE__*/_createTextVNode("去认证 ");

const _hoisted_11 = /*#__PURE__*/_createTextVNode("手机号码");

const _hoisted_12 = /*#__PURE__*/_createTextVNode("修改");

const _hoisted_13 = /*#__PURE__*/_createTextVNode("修改密码");

const _hoisted_14 = /*#__PURE__*/_createTextVNode("修改");

import { onMounted, reactive, ref } from 'vue';
import { useRouter } from "vue-router";
import BaseDialog from '@/components/BaseDialog.vue';
import BaseForm from '@/components/BaseForm.vue';
import localCache from '@/utils/cache';
import { changePasswordFormRule, changePasswordForm, changePhoneFormRule, changePhoneForm } from '@/utils/formSetting.js';
import { certificationTypeTableMap, certificationStatusTableMap } from '@/utils/staticData';
import usePersonalCenterStore from "@/stores/modules/personalCenter";
import useLoginStore from "@/stores/modules/login";
export default {
  __name: 'information',

  setup(__props) {
    const useLogin = useLoginStore();
    const router = useRouter();
    const usePersonalCenter = usePersonalCenterStore();
    let userInfo = ref(null);
    onMounted(async () => {
      userInfo.value = await usePersonalCenter.getPersonalInformation();
    }); // 去认证，跳转到认证页面

    function toAuthentication(type) {
      switch (type) {
        case 'flyAuthenticated':
          router.push({
            path: '/personalCenter/pilot'
          });
          break;

        case 'authenticated':
          router.push({
            path: '/personalCenter/enterprise'
          });
          break;
      }
    } // 修改个人信息（手机号码或者密码）


    function changeInformation(type) {
      dialogData.dialogVisible = true;

      switch (type) {
        case 'mobile':
          dialogData.dialogTitle = '修改手机号码';
          dialogData.dialogForm = changePhoneForm;
          dialogData.dialogFormRule = changePhoneFormRule;
          break;

        case 'password':
          dialogData.dialogTitle = '修改密码';
          dialogData.dialogForm = changePasswordForm;
          dialogData.dialogFormRule = changePasswordFormRule;
          processDefaultData(userInfo.value);
          break;
      }
    }

    function processDefaultData(data) {
      dialogData.dialogForm.forEach(item => {
        item.defaultVal = data[item.prop];
      });
    }

    let dialogData = reactive({
      dialogVisible: false,
      dialogTitle: '修改密码',
      dialogForm: null,
      dialogFormRule: null,
      dialogType: 'change'
    });

    function closeDialog() {
      dialogData.dialogVisible = false;
    }

    let form = ref(null);

    function handleClick(type) {
      if (type === 'cancel') {
        dialogData.dialogVisible = false;
        return;
      }

      let params = JSON.parse(JSON.stringify(form.value.filterForm));
      form.value.form.validate(async (valid, fields) => {
        if (valid) {
          switch (dialogData.dialogTitle) {
            case '修改密码':
              changePassword(params);
              break;

            case '修改手机号码':
              changeMobile(params);
              break;
          }
        }
      });
    }

    async function changePassword(params) {
      if (form.value.filterForm.password !== form.value.filterForm.confirmPassword) {
        ElMessage({
          type: 'error',
          message: '密码不一致'
        });
      } else {
        delete params.confirmPassword;
        delete params.userName;
        params.disabled = 'false';
        let res = await usePersonalCenter.changePassword(params);

        if (res.code === 200) {
          ElMessage({
            type: 'message',
            message: '成功修改，现跳转至登录页面，请重新登录'
          });
          dialogData.dialogVisible = false;
          handleLogout();
        } else {
          ElMessage({
            type: 'error',
            message: res.message
          });
        }
      }
    }

    async function changeMobile(params) {
      let res = await usePersonalCenter.changeMobile(params);

      if (res.code === 200) {
        dialogData.dialogVisible = false;
        ElMessage({
          type: 'message',
          message: '成功修改，现跳转至登录页面，请重新登录'
        });
        handleLogout();
      } else {
        ElMessage({
          type: 'error',
          message: res.message
        });
      }
    } // 修改手机号码或者密码后退出登录


    async function handleLogout() {
      const logoutResult = await useLogin.logout();

      if (logoutResult.code === 200) {
        localCache.clearCache();
        sessionStorage.clear();
        router.push("/login");
      }
    }

    return (_ctx, _cache) => {
      const _component_el_col = __unplugin_components_0;

      const _component_el_row = __unplugin_components_1;

      const _component_el_button = __unplugin_components_2;

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
        class: "item"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 10
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(userInfo)?.userName), 1)]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "item"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 10
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(certificationTypeTableMap)[_unref(userInfo)?.classify] || '-'), 1)]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 4
        }, {
          default: _withCtx(() => [_unref(userInfo)?.authenticatedStatus === 'authorizedSuccess' ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            disabled: true
          }, {
            default: _withCtx(() => [_hoisted_4]),
            _: 1
          })) : (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            type: "primary",
            onClick: _cache[0] || (_cache[0] = $event => toAuthentication('authenticated'))
          }, {
            default: _withCtx(() => [_hoisted_5]),
            _: 1
          }))]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "item"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_hoisted_6]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 10
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(userInfo)?.authenticatedName), 1)]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "item"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_hoisted_7]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 10
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(userInfo)?.company || '-'), 1)]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "item"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_hoisted_8]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 10
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(certificationStatusTableMap)[_unref(userInfo)?.flyAuthenticatedStatus]), 1)]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 4
        }, {
          default: _withCtx(() => [_unref(userInfo)?.flyAuthenticatedStatus === 'authorizedSuccess' ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            disabled: true
          }, {
            default: _withCtx(() => [_hoisted_9]),
            _: 1
          })) : (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            type: "primary",
            onClick: _cache[1] || (_cache[1] = $event => toAuthentication('flyAuthenticated'))
          }, {
            default: _withCtx(() => [_hoisted_10]),
            _: 1
          }))]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "item"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_hoisted_11]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 10
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(userInfo)?.mobile), 1)]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 4
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[2] || (_cache[2] = $event => changeInformation('mobile'))
          }, {
            default: _withCtx(() => [_hoisted_12]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "item"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_hoisted_13]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 10
        }), _createVNode(_component_el_col, {
          span: 4
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[3] || (_cache[3] = $event => changeInformation('password'))
          }, {
            default: _withCtx(() => [_hoisted_14]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(BaseDialog, {
        dialogVisible: _unref(dialogData).dialogVisible,
        dialogTitle: _unref(dialogData).dialogTitle,
        dialogType: _unref(dialogData).dialogType,
        onCloseDialog: closeDialog,
        onHandleClick: handleClick,
        "destroy-on-close": ""
      }, {
        "dialog-content": _withCtx(() => [_createVNode(BaseForm, {
          ref_key: "form",
          ref: form,
          formSet: _unref(dialogData).dialogForm,
          formRule: _unref(dialogData).dialogFormRule,
          dialogType: _unref(dialogData).dialogType
        }, null, 8, ["formSet", "formRule", "dialogType"])]),
        _: 1
      }, 8, ["dialogVisible", "dialogTitle", "dialogType"])]);
    };
  }

};